import { P, match } from "ts-pattern";
import { ControlDataTypeKey, Types } from "../prop-controllers";
import { z } from "zod";
import {
  responsiveLengthDataSchema
} from "../responsive-length";
const widthPropControllerDataV0Schema = responsiveLengthDataSchema;
const WidthPropControllerDataV1Type = "prop-controllers::width::v1";
const widthPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(WidthPropControllerDataV1Type),
  value: responsiveLengthDataSchema
});
const widthPropControllerDataSchema = z.union([
  widthPropControllerDataV0Schema,
  widthPropControllerDataV1Schema
]);
const WidthPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::width::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::width::format::responsive-value"
};
function Width(options = {}) {
  return { type: Types.Width, version: 1, options };
}
Width.Format = WidthPropControllerFormat;
function getWidthPropControllerDataResponsiveLengthData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: WidthPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createWidthPropControllerDataFromResponsiveLengthData(responsiveLengthData, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: WidthPropControllerDataV1Type,
      value: responsiveLengthData
    })
  ).otherwise(() => responsiveLengthData);
}
export {
  Width,
  WidthPropControllerDataV1Type,
  WidthPropControllerFormat,
  createWidthPropControllerDataFromResponsiveLengthData,
  getWidthPropControllerDataResponsiveLengthData,
  widthPropControllerDataSchema
};
//# sourceMappingURL=width.js.map